import { createFileRoute } from '@tanstack/react-router';

import { ParticipantsGrid, QueryBoundary } from '../../../../../components';

const Page = () => {
  const { advisoryOrganizationId, planId } = Route.useParams();

  return (
    <ParticipantsGrid
      advisoryOrganizationId={advisoryOrganizationId}
      planId={planId}
    />
  );
};

export const Route = createFileRoute(
  '/organizations/$advisoryOrganizationId/plans/$planId/participants'
)({
  component: () => (
    <QueryBoundary>
      <Page />
    </QueryBoundary>
  )
});
